module.exports = __webpack_public_path__ + "img/membership-banner.be93df33.png";